import { lazy, Suspense } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { StaffProvider } from './lib/staffContext';
import { ToastProvider } from './components/Toast';
import { AppShell } from './components/AppShell';
import { Loading } from './components/ui';
import { DeviceProvider } from './lib/device';

const LoginPage = lazy(() => import('./app/login/page'));
const TenantsPage = lazy(() => import('./app/tenants/page'));
const ApprovalsPage = lazy(() => import('./app/tenant-approvals/page'));
const LiveAccessPage = lazy(() => import('./app/live-access/page'));
const ReviewQueuePage = lazy(() => import('./app/review-queue/page'));
const SecurityEventsPage = lazy(() => import('./app/security-events/page'));
const AuditChainPage = lazy(() => import('./app/audit-chain/page'));
const SupportQueuePage = lazy(() => import('./app/support-queue/page'));
const BillingReviewPage = lazy(() => import('./app/billing-review/page'));
const DemoTenantsPage = lazy(() => import('./app/demo-tenants/page'));
const ReleaseReadinessPage = lazy(() => import('./app/release-readiness/page'));
const SystemHealthPage = lazy(() => import('./app/system-health/page'));
const SafetyIntelligencePage = lazy(() => import('./app/safety-intelligence/page'));

export function App() {
  return (
    <DeviceProvider>
      <StaffProvider>
        <ToastProvider>
          <BrowserRouter>
            <Suspense fallback={<Loading />}>
              <Routes>
                <Route path="/login" element={<LoginPage />} />
                <Route element={<AppShell />}>
                  <Route path="/tenants" element={<TenantsPage />} />
                  <Route path="/tenant-approvals" element={<ApprovalsPage />} />
                  <Route path="/live-access" element={<LiveAccessPage />} />
                  <Route path="/review-queue" element={<ReviewQueuePage />} />
                  <Route path="/security-events" element={<SecurityEventsPage />} />
                  <Route path="/audit-chain" element={<AuditChainPage />} />
                  <Route path="/support-queue" element={<SupportQueuePage />} />
                  <Route path="/billing-review" element={<BillingReviewPage />} />
                  <Route path="/demo-tenants" element={<DemoTenantsPage />} />
                  <Route path="/release-readiness" element={<ReleaseReadinessPage />} />
                  <Route path="/system-health" element={<SystemHealthPage />} />
                  <Route path="/safety-intelligence" element={<SafetyIntelligencePage />} />
                </Route>
                <Route path="*" element={<Navigate to="/tenants" replace />} />
              </Routes>
            </Suspense>
          </BrowserRouter>
        </ToastProvider>
      </StaffProvider>
    </DeviceProvider>
  );
}
